import { Component } from '@angular/core';
import { PayeeIconComponent } from '../../shared/payee-icon/payee-icon.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [PayeeIconComponent, TranslateModule],
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
